<template>
  <span v-if="!url">
    <slot />
  </span>
  <router-link v-else-if="isInternal" :to="relativeUrl" :class="bemBlock">
    <slot />
  </router-link>
  <a v-else target="_blank" :href="url" :class="bemBlock">
    <slot />
  </a>
</template>

<script>
import bemClassesMixin from '../mixins/bemClassesMixin';
import { parseRelativeUrl } from '../../common/utils/url';

export default {
  name: 'BaseLink',

  mixins: [bemClassesMixin],

  props: {
    url: {
      type: String,
      default: null,
      required: false,
    },
    type: {
      type: String,
      default: 'internal',
      required: false,
      validator: (prop) =>
        ['product', 'category', 'internal', 'external'].some(
          (type) => prop === type
        ),
    },
    ID: {
      // eslint-disable-line vue/prop-name-casing
      type: [String, Number],
      default: null,
      required: false,
    },
  },

  computed: {
    relativeUrl() {
      if (this.isInternal) {
        return parseRelativeUrl(this.url);
      }
      return this.url;
    },
    isInternal() {
      return ['product', 'category', 'internal'].includes(this.type);
    },
  },
};
</script>
